<template>
  <div>
    <b-navbar variant="light" class="pl-4 pr-4" style="clear: both;">
      <b-navbar-nav>
        <router-link to="/about" custom v-slot="{ navigate }" class="centerMax589">
          <b-nav-item @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
            {{ $t("tFooter.about") }}
          </b-nav-item>
        </router-link>

        <router-link to="/tos" custom v-slot="{ navigate }" class="centerMax589">
          <b-nav-item @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
            {{ $t("tFooter.tos") }}
          </b-nav-item>
        </router-link>

        <router-link to="/privacy" custom v-slot="{ navigate }" class="centerMax589">
          <b-nav-item @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
            {{ $t("tFooter.privacy") }}
          </b-nav-item>
        </router-link>

      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="footer-copyright font-small float-right text-right">
          &copy; 2020
          <span>{{ $t("tFooter.tinkable") }}</span>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>
<script>
import eventBus from '@/plugins/eventBus.js'
import uiUtil from "@/mixins/util.js"
import { mapState } from "vuex"
import { mapSetter } from "@/plugins/vuexUtils.js"
import { mapActions } from "vuex"
export default {
  name: "tFooter",
  mixins: [uiUtil],
  props: {
    links: Array,
    copyright: String
  },
}
</script>
